// extracted by mini-css-extract-plugin
export default {"spinner-container-submit":"Loading_spinner-container-submit__HpFTf","spinner":"Loading_spinner__3Vnwt","rotating-spinner":"Loading_rotating-spinner__b1e6G"};